export default __webpack_public_path__ + "static/media/platformDeviceIcon5.c5aab5b9.webp";